import axios from 'axios';

export const getData = (url, succesHandler, errorHandler) => {
	axios.get(url)
		.then(response => succesHandler(response.data)) 
		.catch(error => errorHandler(error));
}